import {ResidentForSelect} from './ResidentForSelect';

export class Parcel {
    private _residents: ResidentForSelect[]; // @danger look at this during merge

    static fromExistingData(item: any): Parcel {
        const parcel = new Parcel();
        if (item.id) parcel.id = +item.id;
        if (item.suite) parcel.suiteId = +item.suite.bdId;
        if (item.building) parcel.building = item.building;
        if (item.suite) parcel.suiteNumber = item.suite.suiteNumber;
        if (item.parcelType) parcel.parcelTypeId = +item.parcelType.id;
        if (item.parcelType) parcel.parcelTypeName = item.parcelType.name;
        if (item.parcelPostService) parcel.parcelPostServiceId = +item.parcelPostService.id; // do not miss this part during merging!!!
        if (item.parcelPostService) parcel.parcelPostServiceName = item.parcelPostService.name; // do not miss this part during merging!!!
        if (item.parcelPostServiceName) parcel.parcelPostServiceName = item.parcelPostServiceName; // do not miss this part during merging!!!
        if (item.returningBy) parcel.returningById = item.returningBy.id;
        if (item.returningBy) parcel.returningByName = item.returningBy.name;
        if (item.building) parcel.buildingId = +item.building.bdId;
        if (item.building) parcel.buildingName = item.building.name;
        if (item.building) parcel.corporationNumberBd = item.building.corporationNumberBd;
        if (item.resident) parcel.residentId = +item.resident.bdId;
        if (item.resident) parcel.residentFullName = item.resident.fullName;
        if (item.resident) parcel.residentEmail = item.resident.email;
        if (item.resident) parcel.residentPhone = item.resident.phone;
        if (item.resident) parcel.residentMobilePhone = item.resident.mobilePhone;
        if (item.receivedBy) parcel.receivedById = +item.receivedBy.id;
        if (item.receivedBy) parcel.receivedByFullName = item.receivedBy.fullName;
        if (item.receivedBy) parcel.receivedByEmail = item.receivedBy.email;
        if (item.pickedUpBy) parcel.pickedUpById = +item.pickedUpBy.id;
        if (item.pickedUpBy) parcel.pickedUpByFullName = item.pickedUpBy.fullName;
        if (item.pickedUpBy) parcel.pickedUpByEmail = item.pickedUpBy.email;
        if (item.cancelledBy) parcel.cancelledByFullName = item.cancelledBy.fullName;
        if (item.deliveredBy) parcel.deliveredById = +item.deliveredBy.id;
        if (item.deliveredBy) parcel.deliveredByFullName = item.deliveredBy.fullName;
        if (item.deliveredBy) parcel.deliveredByEmail = item.deliveredBy.email;
        if (item.barCode) parcel.barCode = item.barCode;
        if (item.numberPieces) parcel.numberPieces = +item.numberPieces;
        if (item.deliveryAddress) parcel.deliveryAddress = item.deliveryAddress;
        if (item.description) parcel.description = item.description;
        if (item.notes) parcel.notes = item.notes;
        if (item.status) parcel.status = item.status;
        if (item.inOut) parcel.inOut = item.inOut;
        if (item.createdAt) parcel.createdAt = item.createdAt;
        if (item.pickedUpAt) parcel.pickedUpAt = item.pickedUpAt;
        if (item.pickedUpByPostService) parcel.pickedUpByPostService = item.pickedUpByPostService.id;
        if (item.pickedUpByPostService) parcel.pickedUpByPostServiceName = item.pickedUpByPostService.name;
        if (item.parcelHistory) parcel.parcelHistory = item.parcelHistory;
        if (item.parcelNumber) parcel.parcelNumber = item.parcelNumber;
        if (item.signUrl) parcel.signUrl = item.signUrl;
        if (item.emailNotice) parcel.emailNotice = true;
        if (item.reminderSentAt) parcel.reminderSentAt = item.reminderSentAt;
        parcel.isCanEdit = item.isCanEdit;
        parcel.isCanDelete = item.isCanDelete;
        if (!item.parcelPostService && item.parcelPostServiceName) {
            parcel.parcelPostServiceId = -1; // other parcel post service chosen
        }
        return parcel;
    }

    constructor(
        public id: number = null,
        public building: { address: number, bdId: number, corporationNumberBd: number, name: string, timeZone: string } = null,
        public suiteId: number = null,
        public suiteNumber: string = '',
        public parcelTypeId: number = null,
        public parcelTypeName: string = '',
        public parcelPostServiceId: number = null,
        public parcelPostServiceName: string = '',
        public returningById: string = '',
        public returningByName: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public corporationNumberBd: number = null,
        public residentId: number = null,
        public residentFullName: string = '',
        public residentEmail: string = '',
        public residentPhone: string = '',
        public residentMobilePhone: string = '',
        public receivedById: number = null,
        public receivedByFullName: string = '',
        public receivedByEmail: string = '',
        public pickedUpById: number = null,
        public pickedUpByFullName: string = '',
        public cancelledByFullName: string = '',
        public pickedUpByEmail: string = '',
        public deliveredById: number = null,
        public deliveredByFullName: string = '',
        public deliveredByEmail: string = '',
        public barCode: string = '',
        public numberPieces: number = null,
        public deliveryAddress: string = '',
        public description: string = '',
        public notes: string = '',
        public status: string = '',
        public inOut: string = 'Incoming',
        public createdAt: string = '',
        public pickedUpAt: string = '',
        public pickedUpByPostService: string = '',
        public pickedUpByPostServiceName: string = '',
        public parcelHistory: Array<number> = [],
        public parcelNumber: string = '',
        public signUrl: string = '',
        public emailNotice: boolean = false,
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public checked: boolean = false,
        public showDetailedView: boolean = false,
        public reminderSentAt: string = '',
        public formFields = {
            barCode: {editMode: false},
            numberPieces: {editMode: false},
            parcelPostService: {editMode: false},
            parcelType: {editMode: false},
            building: {editMode: false},
            unit: {editMode: false},
            resident: {editMode: false},
            description: {editMode: false},
        }
    ) {
    }

    isIncomingParcel() {
        return this.inOut === 'Incoming';
    }

    isOutgoingParcel() {
        return this.inOut === 'Outgoing';
    }

    get residents(): ResidentForSelect[] { // @danger look at this during merge
        return this._residents;
    }

    set residents(value: ResidentForSelect[]) { // @danger look at this during merge
        this._residents = value;
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Parcel.ts